var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.084,
    height: 66.084,
    viewBox: "0 0 17.485 17.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    style: {
      opacity: 1,
      strokeWidth: 0.208639
    },
    transform: "translate(-.025 -2.34)scale(1.26814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.284 5.737 12.07 6.951a.316.316 0 0 1-.448 0L8.7 4.028a.316.316 0 0 1 0-.448l1.214-1.214a1.267 1.267 0 0 1 1.788 0l1.583 1.583a1.26 1.26 0 0 1 0 1.788M7.656 4.623.739 11.539l-.558 3.2c-.076.432.3.806.732.733l3.2-.561 6.917-6.917a.316.316 0 0 0 0-.448L8.106 4.623a.32.32 0 0 0-.45 0m-4.217 6.324a.367.367 0 0 1 0-.522L7.495 6.37a.367.367 0 0 1 .522 0 .367.367 0 0 1 0 .522L3.96 10.947a.367.367 0 0 1-.522 0m-.95 2.215h1.263v.956l-1.698.298-.82-.82.298-1.698h.956z",
    style: {
      strokeWidth: 0.208639
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.19f598144ec395614c09644891dfecd1.svg";
export { ForwardRef as ReactComponent };